export default __webpack_public_path__ + "static/media/venture.a55e80a8.svg";